module.exports = "<div class=\"auth\">\n    <div ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/routes/auth/auth.html
// module id = 99
// module chunks = 0